import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Card from "react-bootstrap/esm/Card";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import { getAllActivePostsByAddress, selectAllActivePosts, getTrainerId, getSinglePost, addPostSearch, getPostSearchResults, getPostComments} from "../../state/blogSlice";
import { useParams } from "react-router";


function LiveViewSidebar() {
    let dispatch = useDispatch();
    let { pageAddress } = useParams();

    const [postSearch, setPostSearch] = useState("");
    const [recentPosts, setRecentPosts] = useState([]);
    const [filter, setFilter] = useState("")

    let activePosts = useSelector(selectAllActivePosts)
    const pageTrainerId = useSelector(state => state?.posts?.trainerId);
    const currentUser = useSelector(state => state?.users?.current_user?.user_id_number);

    useEffect(() => {
        let payload = {
            pageAddress: pageAddress,
            action: 'getTrainerId'
        }
        dispatch(getTrainerId(payload))
    }, [])

    // for extra menu options like "manage blogs"
    useEffect(() => {
        if (pageTrainerId === currentUser) {
            setFilter("trainerOwnPost")
        }
    }, [pageTrainerId, currentUser])


    useEffect(() => {
        let payload = {
            pageAddress: pageAddress,
            action: 'getAllActivePostsByAddress'
        }
        dispatch(getAllActivePostsByAddress(payload))
    }, [])

    // set five most recent posts
    useEffect(() => {
        let recentPosts = activePosts.slice(0, 5);
        setRecentPosts(recentPosts)
    }, [activePosts])


    function handlePostSearch() {
        let payload = {
            searched: postSearch
        }
        dispatch(addPostSearch(payload))

        let payloadSearch = {
            search: postSearch,
            pageAddress,
            action: "getPostSearchResults"
        };
        dispatch(getPostSearchResults(payloadSearch))
    }

    return (
        <Col lg="3" style={{ marginTop: "80px" }} className="mx-0 px-0">
            <Card className="bg-light mb-3">
                <Card.Header style={{ border: "none" }}>
                    <h4>Menu</h4>
                </Card.Header>
                <Card.Body>
                    <ul class="list-group list-group-flush">
                        <Link to={`/${pageAddress}/blog`}> <li className="list-group-item mb-3"> View All Blogs </li> </Link>
                        {filter === "trainerOwnPost" && <Link to={"/myBlog"}> <li className="list-group-item"> Manage Blogs </li> </Link>}
                    </ul>
                </Card.Body>
            </Card>

            <Card className="bg-light mb-3">
                <Card.Header>
                    <h4>Search</h4>
                </Card.Header>
                <Card.Body>
                    <Form.Group className="d-flex" >
                        <Form.Control type="text" value={postSearch} onChange={(e) => {
                            setPostSearch(e.target.value);
                        }} />
                        <Link onClick={() => { handlePostSearch(postSearch) }} to={`/${pageAddress}/blog/search/`}>
                            <Button  >
                                <span className="fa fa-search"></span>
                            </Button>
                        </Link>
                    </Form.Group>
                </Card.Body>
            </Card>
            {recentPosts && <Card className="bg-light mb-3">
                <Card.Header>
                    <h4>Recent Posts</h4>
                </Card.Header>
                <Card.Body>
                    {recentPosts.map(post => {
                        return (
                            <div key={post.post_id}>
                                <div className="mb-3">
                                    <Link onClick={() => {
                                        let payload = {
                                            pageAddress,
                                            post_slug: post.post_slug,
                                            action: "getSinglePost"
                                        }
                                        
                                        dispatch(getSinglePost(payload))
                                        .then(res => {
                                            if (res.payload.success === "1") {
                                                let post_id = res.payload.data.post.post_id
                                                let payload = {
                                                    pageAddress,
                                                    post_id,
                                                    action: "getPostComments"
                                                }
                                                dispatch(getPostComments(payload))
                                            }
                                        })
                                    }}
                                        to={`/${pageAddress}/blog/${post.post_slug}/`}> {post.post_title}  </Link>
                                    <div><i><span class="far fa-clock"></span> <small>Published on  {post.date_added}</small></i></div>
                                </div>

                                <hr />
                            </div>
                        )
                    })}
                </Card.Body>
            </Card>}
        </Col >
    )

}
export default LiveViewSidebar;
